const routePaths = {
  UPDATE_USER: '/user/update',
  UPDATE_USER_BASIC: '/user/update-basic',
  SKILLS: '/skills',
  CHECK_PUBLIC_USERNAME: '/user/public-username/check',
  CHECK_AWS_USERNAME: '/user/aws-username/check',
  SEND_MAIL_WHEN_VERIFY_EMAIL: '/user/sendmail-when-verify-email',
  UPDATE_PROFILE_PICTURE: '/user/profile-picture/update',
  GET_TOKEN_PORTAL: '/user/token-portal',
  UPDATE_REDEEM_CODE: (codeId) => `/redeem-code/codes/${codeId}`,
  GET_PUBLIC_USER_INFO: '/public-profile/user-info',
  GET_PUBLIC_USER_TEAMS: '/public-profile/teams',
  PRODUCTS: '/products',
  PRODUCT: (courseId) => `/products/${courseId}`,
  GET_PRODUCT_BY_TRANSACTION: '/get-product-by-txn',
  SUBMIT_ORDER: '/submit-order',
  VALIDATE_DISCOUNT_CODE: '/purchase/validate-discount-code',
  REJECT_ORDER: '/reject-order',

  CREATE_PAYMENT_URL: '/vnpay/create-payment-url',
  CHECK_TRANSACTION_VNPAY: '/vnpay/vnpay-return',

  /** PAYPAL PURCHASE API */
  CREATE_ORDER_PAYPAL: '/paypal/create-order',
  CAPTURE_ORDER_PAYPAL: '/paypal/capture-order',
  GET_PRODUCT_BY_PAYPAL_TRANSACTION: '/get-product-by-paypal-txn',
  CHECK_TRANSACTION_PAYPAL: '/paypal/check-paypal-txn',

  /** KAT/KYTE PURCHASE API */
  CREATE_KAT_PAYMENT: '/kat/create-payment-url',
  SUBMIT_KAT_TRANSACTION: '/kat/kat-return',
  CREATE_KYTE_PAYMENT: '/kyte/create-payment-url',
  SUBMIT_KYTE_TRANSACTION: '/kyte/kyte-return',

  /** KAT/KYTE WALLET PURCHASE API */
  HANDLE_KWALLET_PURCHASE: '/kWallet/handle-purchase-k-wallet',

  /** TRACKING UTM API */
  SAVE_UTM_TRACKING: '/user/utm-tracking',

  SUBMIT_REQUEST_WITHDRAW: '/kWallet/request-withdraw',
  SUBMIT_DEPOSIT: '/kWallet/deposit',
  GET_KWALLET_HISTORY: '/kWallet/get-kwallet-history',

  /** SALE */
  BUY_OLP: '/sales',
  FETCH_QUOTES: '/quotes',
  FETCH_PRIVATE_OFFERS: '/getprivateoffers',
  FETCH_BUYER: '/buyer',
  FETCH_TOTAL_BUYER: '/total-buyer',
  FETCH_TAB_CONTENTS: '/sale-content-detail/:id',
  UPDATE_PRIVATE_OFFER: '/privateoffer/:id',
  UPDATE_SALE_TRANSACTION: '/sales/:id',
  GET_KAT_AMOUNT: '/sales/get-kat-amount',

  //Vesing Release
  CREATE_VESTING_RELEASE_TRANSACTION: '/vesting-release-transaction',
  GET_LIST_VESTING_RELEASE_TRANSACTION: '/vesting-release-transaction',
  UPDATE_VESTING_RELEASE_TRANSACTION: '/vesting-release-transaction/:id',
  GET_DAO_DETAIL_VESTING_RELEASE_TRANSACTION: '/vesting-release-transaction/:id',

  /** VESTING HISTORY */
  FETCH_VESTING_HISTORY_BY_WALLET_HISTORY: '/vesting-release-history-transaction-by-wallet-address',

  // NFT License
  POST_NFT_TRANSACTION: '/nft/create-transaction',
  GET_LICENSE: "/nft/list-licenses",

  GET_LICENSE_BY_USER: "/nft/list-licenses-of-user",
  GET_TRANSACTION: "/nft/transaction-of-user",

  //sendy
  SUBSCRIBE_SENDY: '/user/subscribe-sendy'
};

export default routePaths;
